// PR6: where MobileShell switches on. isMobileShell() (desktop.ts) covers the Android/iOS
// Tauri hybrid shell; the viewport query covers a phone's own browser hitting the same web
// build. Either one is enough — the DS mobile layout (artboards 3a-3e) never has to share a
// screen with the sidebar/topbar chrome.
import { useEffect, useState } from "react";
import { isMobileShell } from "../desktop";

export const MOBILE_MEDIA_QUERY = "(max-width: 600px)";

export function isNarrowViewport(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
}

/** True once per render when the DS mobile layout (MobileShell and friends) should be used. */
export function useIsMobileLayout(): boolean {
  const [narrow, setNarrow] = useState(isNarrowViewport);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = () => setNarrow(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobileShell() || narrow;
}
